module.exports = __webpack_public_path__ + "img/FF_Info_Game_1.40c7e37d.png";